var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMedium(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 16,
    width: 16,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.62 13.847a.667.667 0 01-.393-.127L8 11.38l-3.227 2.34a.667.667 0 01-1.026-.747L4.98 9.18 1.753 6.84a.667.667 0 01.394-1.207h4L7.38 1.84A.667.667 0 018 1.38a.667.667 0 01.633.46l1.234 3.793h4a.666.666 0 01.393 1.207l-3.227 2.34 1.234 3.793a.667.667 0 01-.634.874z",
    fill: "#121314"
  })));
}
export default SvgMedium;